"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const de_json_1 = __importDefault(require("./de.json"));
const en_json_1 = __importDefault(require("./en.json"));
const fr_json_1 = __importDefault(require("./fr.json"));
const sq_json_1 = __importDefault(require("./sq.json"));
exports.default = {
    de: de_json_1.default,
    en: en_json_1.default,
    fr: fr_json_1.default,
    sq: sq_json_1.default,
};
//# sourceMappingURL=index.js.map